import { namespaces } from '@common'

export const namespace = namespaces.insurance.value
export const schema = 'contractSchema'
export const backendDocType = 'Contract'
export const docPrivilege = 'insurance'
